/**
 * @fileoverview Animals theme - match animal emojis.
 */

import { ThemeOptions } from '../../../services/ThemeService.js';
import { EmojiMatchingTheme } from '../../abstract/EmojiMatchingTheme.js';
import { allLabels } from '../../Labels.js';

export class SymbolsTheme extends EmojiMatchingTheme {
    constructor(options: ThemeOptions = {}) {
        super(
            'symbols',
            'Symbols',
            allLabels.symbols,
            { numPairs: 6, ...options }
        );
    }
}
